import type { FC } from "react";

import { EarnPoints as UIEarnPoints } from "@jti/loyalty/components/EarnPoints";

import type { earnPointsInputs } from "./EarnPoints.builder";

export type EarnPointsBuilderProps = BuilderComponentProps<typeof earnPointsInputs>;

export const EarnPoints: FC<EarnPointsBuilderProps> = ({
  header,
  title,
  details,
  subtitle,
  subtitleDetails,
  pointsLabel,
  loadBaseItems,
  loadMoreItems,
  pointsList,
  componentId,
}) => {
  return (
    <UIEarnPoints
      header={header}
      title={title}
      details={details}
      subtitle={subtitle}
      subtitleDetails={subtitleDetails}
      pointsLabel={pointsLabel}
      loadBaseItems={loadBaseItems}
      pointsList={pointsList}
      loadMoreItems={loadMoreItems}
      componentId={componentId}
    />
  );
};
